import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {injectIntl} from "@irati/utils/lang"
import getMessage from "@irati/utils/lang/helpers/getMessage"
import id from "@irati/utils/id"
import {SAVED_AS_DRAFT, READY_TO_LAUNCH, LAUNCHED, IN_PROGRESS, STOPPED, ARCHIVED} from "@irati/insights/constants/schedule"
import {injectRoute} from "@irati/utils/helpers/routing"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

import Archive from "./Archive"
import Restore from "./Restore"
import Stop from "./Stop/Stop"
import Delete from "./Delete"
import Launch from "./Launch"
import SendExampleSurvey from "./SendExampleSurvey"
import {Menu} from "../../../ui/Menu"
import sitemap from "../../../routes/sitemap"
import {withHandleAction} from "./HandleAction"
import {getActiveActions} from "../../../helpers/cycleCardCTAs/getCycleCardCTAs"

const StyledButton = styled(Button)`
  ${({theme}) => `
    margin-right: ${theme.spacing.two};
  `}
`
const MIN_LENGTH = 1

class ActionList extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  getActionList = () => [
    {
      label: getMessage(this, "insights.cycleCard.cta.launch"),
      action: () => this.launch && this.launch.handleAction(),
      visibleStatuses: [READY_TO_LAUNCH, STOPPED],
      primaryStatuses: [READY_TO_LAUNCH],
      icon: "launch"
    },
    {
      label: getMessage(this, "insights.cycleCard.cta.editSettings"),
      action: injectRoute(sitemap.scheduleEdit.url, {scheduleId: this.props.schedule.id}),
      visibleStatuses: [READY_TO_LAUNCH, IN_PROGRESS, SAVED_AS_DRAFT, LAUNCHED, STOPPED],
      primaryStatuses: [SAVED_AS_DRAFT, LAUNCHED],
      icon: "edit"
    },
    {
      label: getMessage(this, "insights.cycleCard.cta.seeResults"),
      action: injectRoute(sitemap.analysis.url, {scheduleId: this.props.schedule.id}),
      visibleStatuses: [IN_PROGRESS, STOPPED],
      primaryStatuses: [IN_PROGRESS, STOPPED],
      icon: "seeResults"
    },
    {
      label: getMessage(this, "insights.cycleCard.cta.sendExampleSurvey"),
      action: () => this.sendExampleSurvey && this.sendExampleSurvey.handleAction(),
      visibleStatuses: [READY_TO_LAUNCH, IN_PROGRESS, SAVED_AS_DRAFT, LAUNCHED, STOPPED],
      primaryStatuses: [],
      icon: "sendExampleSurvey"
    },
    {
      label: getMessage(this, "insights.cycleCard.cta.stopSurvey"),
      action: () => this.stop && this.stop.handleAction(),
      visibleStatuses: [LAUNCHED, IN_PROGRESS],
      primaryStatuses: [],
      icon: "stop"
    },
    {
      label: getMessage(this, "insights.homepage.actions.archive.label"),
      action: () => this.archive && this.archive.handleAction(),
      visibleStatuses: [READY_TO_LAUNCH, SAVED_AS_DRAFT, LAUNCHED, STOPPED],
      primaryStatuses: [],
      icon: "archive"
    },
    {
      label: getMessage(this, "Restore"),
      action: () => this.restore && this.restore.handleAction(),
      visibleStatuses: [ARCHIVED],
      primaryStatuses: [ARCHIVED],
      icon: "restore"
    },
    {
      label: getMessage(this, "Delete"),
      action: () => this.delete && this.delete.handleAction(),
      visibleStatuses: [ARCHIVED],
      primaryStatuses: [],
      icon: "delete"
    }
  ]

  render() {
    const {schedule, onChange} = this.props
    const idNamespace = id("action-list", this.props)
    const actions = getActiveActions(schedule, this.getActionList())
    const ButtonComp = withHandleAction(StyledButton)
    const [primaryButton, ...secondaryButtonOptions] = actions
    const isDropDownMenu = secondaryButtonOptions.length > MIN_LENGTH

    return (
      <Flex alignItems="center">
        <ButtonComp primary item={primaryButton}>
          {primaryButton.label}
        </ButtonComp>
        {isDropDownMenu && (
          <Menu label={getMessage(this, "insights.homepage.actions.dropdownLabel")} id={idNamespace} items={secondaryButtonOptions} />
        )}
        {!isDropDownMenu && (
          <ButtonComp item={secondaryButtonOptions[0]}>
            {secondaryButtonOptions[0].label}
          </ButtonComp>
        )}

        <Archive
          id={idNamespace}
          ref={(archive) => {
            this.archive = archive
          }}
          schedule={schedule}
          onChange={onChange} />
        <Restore
          id={idNamespace}
          ref={(restore) => {
            this.restore = restore
          }}
          schedule={schedule}
          onChange={onChange} />
        <Delete
          id={idNamespace}
          ref={(deleteAction) => {
            this.delete = deleteAction
          }}
          schedule={schedule}
          onChange={onChange} />
        <Launch
          id={idNamespace}
          ref={(launch) => {
            this.launch = launch
          }}
          schedule={schedule}
          onChange={onChange} />
        <SendExampleSurvey
          id={idNamespace}
          ref={(sendExampleSurvey) => {
            this.sendExampleSurvey = sendExampleSurvey
          }}
          scheduleId={schedule.id} />
        <Stop
          id={idNamespace}
          ref={(stop) => {
            this.stop = stop
          }}
          schedule={schedule}
          onChange={onChange} />
      </Flex>
    )
  }
}

export default injectIntl(ActionList)
